function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2017 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { getAncestorRootNodes } from '@vaadin/component-base/src/dom-utils.js';
var PROP_NAMES_VERTICAL = {
  start: 'top',
  end: 'bottom'
};
var PROP_NAMES_HORIZONTAL = {
  start: 'left',
  end: 'right'
};
var targetResizeObserver = new ResizeObserver(function (entries) {
  setTimeout(function () {
    entries.forEach(function (entry) {
      if (entry.target.__overlay) {
        entry.target.__overlay._updatePosition();
      }
    });
  });
});
/**
 * @polymerMixin
 */

export var PositionMixin = function PositionMixin(superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(PositionMixin, _superClass);

    var _super = _createSuper(PositionMixin);

    function PositionMixin() {
      var _this;

      _classCallCheck(this, PositionMixin);

      _this = _super.call(this);
      _this.__onScroll = _this.__onScroll.bind(_assertThisInitialized(_this));
      _this._updatePosition = _this._updatePosition.bind(_assertThisInitialized(_this));
      return _this;
    }
    /** @protected */


    _createClass(PositionMixin, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(PositionMixin.prototype), "connectedCallback", this).call(this);

        if (this.opened) {
          this.__addUpdatePositionEventListeners();
        }
      }
      /** @protected */

    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(PositionMixin.prototype), "disconnectedCallback", this).call(this);

        this.__removeUpdatePositionEventListeners();
      }
      /** @private */

    }, {
      key: "__addUpdatePositionEventListeners",
      value: function __addUpdatePositionEventListeners() {
        var _this2 = this;

        window.addEventListener('resize', this._updatePosition);
        this.__positionTargetAncestorRootNodes = getAncestorRootNodes(this.positionTarget);

        this.__positionTargetAncestorRootNodes.forEach(function (node) {
          node.addEventListener('scroll', _this2.__onScroll, true);
        });
      }
      /** @private */

    }, {
      key: "__removeUpdatePositionEventListeners",
      value: function __removeUpdatePositionEventListeners() {
        var _this3 = this;

        window.removeEventListener('resize', this._updatePosition);

        if (this.__positionTargetAncestorRootNodes) {
          this.__positionTargetAncestorRootNodes.forEach(function (node) {
            node.removeEventListener('scroll', _this3.__onScroll, true);
          });

          this.__positionTargetAncestorRootNodes = null;
        }
      }
      /** @private */

    }, {
      key: "__overlayOpenedChanged",
      value: function __overlayOpenedChanged(opened, positionTarget) {
        var _this4 = this;

        this.__removeUpdatePositionEventListeners();

        if (positionTarget) {
          positionTarget.__overlay = null;
          targetResizeObserver.unobserve(positionTarget);

          if (opened) {
            this.__addUpdatePositionEventListeners();

            positionTarget.__overlay = this;
            targetResizeObserver.observe(positionTarget);
          }
        }

        if (opened) {
          var computedStyle = getComputedStyle(this);

          if (!this.__margins) {
            this.__margins = {};
            ['top', 'bottom', 'left', 'right'].forEach(function (propName) {
              _this4.__margins[propName] = parseInt(computedStyle[propName], 10);
            });
          }

          this.setAttribute('dir', computedStyle.direction);

          this._updatePosition(); // Schedule another position update (to cover virtual keyboard opening for example)


          requestAnimationFrame(function () {
            return _this4._updatePosition();
          });
        }
      }
    }, {
      key: "__positionSettingsChanged",
      value: function __positionSettingsChanged() {
        this._updatePosition();
      }
      /** @private */

    }, {
      key: "__onScroll",
      value: function __onScroll(e) {
        // If the scroll event occurred inside the overlay, ignore it.
        if (!this.contains(e.target)) {
          this._updatePosition();
        }
      }
    }, {
      key: "_updatePosition",
      value: function _updatePosition() {
        if (!this.positionTarget || !this.opened) {
          return;
        }

        var targetRect = this.positionTarget.getBoundingClientRect(); // Detect the desired alignment and update the layout accordingly

        var shouldAlignStartVertically = this.__shouldAlignStartVertically(targetRect);

        this.style.justifyContent = shouldAlignStartVertically ? 'flex-start' : 'flex-end';
        var isRTL = this.__isRTL;

        var shouldAlignStartHorizontally = this.__shouldAlignStartHorizontally(targetRect, isRTL);

        var flexStart = !isRTL && shouldAlignStartHorizontally || isRTL && !shouldAlignStartHorizontally;
        this.style.alignItems = flexStart ? 'flex-start' : 'flex-end'; // Get the overlay rect after possible overlay alignment changes

        var overlayRect = this.getBoundingClientRect(); // Obtain vertical positioning properties

        var verticalProps = this.__calculatePositionInOneDimension(targetRect, overlayRect, this.noVerticalOverlap, PROP_NAMES_VERTICAL, this, shouldAlignStartVertically); // Obtain horizontal positioning properties


        var horizontalProps = this.__calculatePositionInOneDimension(targetRect, overlayRect, this.noHorizontalOverlap, PROP_NAMES_HORIZONTAL, this, shouldAlignStartHorizontally); // Apply the positioning properties to the overlay


        Object.assign(this.style, verticalProps, horizontalProps);
        this.toggleAttribute('bottom-aligned', !shouldAlignStartVertically);
        this.toggleAttribute('top-aligned', shouldAlignStartVertically);
        this.toggleAttribute('end-aligned', !flexStart);
        this.toggleAttribute('start-aligned', flexStart);
      }
    }, {
      key: "__shouldAlignStartHorizontally",
      value: function __shouldAlignStartHorizontally(targetRect, rtl) {
        // Using previous size to fix a case where window resize may cause the overlay to be squeezed
        // smaller than its current space before the fit-calculations.
        var contentWidth = Math.max(this.__oldContentWidth || 0, this.$.overlay.offsetWidth);
        this.__oldContentWidth = this.$.overlay.offsetWidth;
        var viewportWidth = Math.min(window.innerWidth, document.documentElement.clientWidth);
        var defaultAlignLeft = !rtl && this.horizontalAlign === 'start' || rtl && this.horizontalAlign === 'end';
        return this.__shouldAlignStart(targetRect, contentWidth, viewportWidth, this.__margins, defaultAlignLeft, this.noHorizontalOverlap, PROP_NAMES_HORIZONTAL);
      }
    }, {
      key: "__shouldAlignStartVertically",
      value: function __shouldAlignStartVertically(targetRect) {
        // Using previous size to fix a case where window resize may cause the overlay to be squeezed
        // smaller than its current space before the fit-calculations.
        var contentHeight = this.requiredVerticalSpace || Math.max(this.__oldContentHeight || 0, this.$.overlay.offsetHeight);
        this.__oldContentHeight = this.$.overlay.offsetHeight;
        var viewportHeight = Math.min(window.innerHeight, document.documentElement.clientHeight);
        var defaultAlignTop = this.verticalAlign === 'top';
        return this.__shouldAlignStart(targetRect, contentHeight, viewportHeight, this.__margins, defaultAlignTop, this.noVerticalOverlap, PROP_NAMES_VERTICAL);
      } // eslint-disable-next-line max-params

    }, {
      key: "__shouldAlignStart",
      value: function __shouldAlignStart(targetRect, contentSize, viewportSize, margins, defaultAlignStart, noOverlap, propNames) {
        var spaceForStartAlignment = viewportSize - targetRect[noOverlap ? propNames.end : propNames.start] - margins[propNames.end];
        var spaceForEndAlignment = targetRect[noOverlap ? propNames.start : propNames.end] - margins[propNames.start];
        var spaceForDefaultAlignment = defaultAlignStart ? spaceForStartAlignment : spaceForEndAlignment;
        var spaceForOtherAlignment = defaultAlignStart ? spaceForEndAlignment : spaceForStartAlignment;
        var shouldGoToDefaultSide = spaceForDefaultAlignment > spaceForOtherAlignment || spaceForDefaultAlignment > contentSize;
        return defaultAlignStart === shouldGoToDefaultSide;
      }
      /**
       * Returns an adjusted value after resizing the browser window,
       * to avoid wrong calculations when e.g. previously set `bottom`
       * CSS property value is larger than the updated viewport height.
       * See https://github.com/vaadin/web-components/issues/4604
       */

    }, {
      key: "__adjustBottomProperty",
      value: function __adjustBottomProperty(cssPropNameToSet, propNames, currentValue) {
        var adjustedProp;

        if (cssPropNameToSet === propNames.end) {
          // Adjust horizontally
          if (propNames.end === PROP_NAMES_VERTICAL.end) {
            var viewportHeight = Math.min(window.innerHeight, document.documentElement.clientHeight);

            if (currentValue > viewportHeight && this.__oldViewportHeight) {
              var heightDiff = this.__oldViewportHeight - viewportHeight;
              adjustedProp = currentValue - heightDiff;
            }

            this.__oldViewportHeight = viewportHeight;
          } // Adjust vertically


          if (propNames.end === PROP_NAMES_HORIZONTAL.end) {
            var viewportWidth = Math.min(window.innerWidth, document.documentElement.clientWidth);

            if (currentValue > viewportWidth && this.__oldViewportWidth) {
              var widthDiff = this.__oldViewportWidth - viewportWidth;
              adjustedProp = currentValue - widthDiff;
            }

            this.__oldViewportWidth = viewportWidth;
          }
        }

        return adjustedProp;
      }
      /**
       * Returns an object with CSS position properties to set,
       * e.g. { top: "100px" }
       */
      // eslint-disable-next-line max-params

    }, {
      key: "__calculatePositionInOneDimension",
      value: function __calculatePositionInOneDimension(targetRect, overlayRect, noOverlap, propNames, overlay, shouldAlignStart) {
        var _ref;

        var cssPropNameToSet = shouldAlignStart ? propNames.start : propNames.end;
        var cssPropNameToClear = shouldAlignStart ? propNames.end : propNames.start;
        var currentValue = parseFloat(overlay.style[cssPropNameToSet] || getComputedStyle(overlay)[cssPropNameToSet]);

        var adjustedValue = this.__adjustBottomProperty(cssPropNameToSet, propNames, currentValue);

        var diff = overlayRect[shouldAlignStart ? propNames.start : propNames.end] - targetRect[noOverlap === shouldAlignStart ? propNames.end : propNames.start];
        var valueToSet = adjustedValue ? "".concat(adjustedValue, "px") : "".concat(currentValue + diff * (shouldAlignStart ? -1 : 1), "px");
        return _ref = {}, _defineProperty(_ref, cssPropNameToSet, valueToSet), _defineProperty(_ref, cssPropNameToClear, ''), _ref;
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * The element next to which this overlay should be aligned.
           * The position of the overlay relative to the positionTarget can be adjusted
           * with properties `horizontalAlign`, `verticalAlign`, `noHorizontalOverlap`
           * and `noVerticalOverlap`.
           */
          positionTarget: {
            type: Object,
            value: null,
            sync: true
          },

          /**
           * When `positionTarget` is set, this property defines whether to align the overlay's
           * left or right side to the target element by default.
           * Possible values are `start` and `end`.
           * RTL is taken into account when interpreting the value.
           * The overlay is automatically flipped to the opposite side when it doesn't fit into
           * the default side defined by this property.
           *
           * @attr {start|end} horizontal-align
           */
          horizontalAlign: {
            type: String,
            value: 'start',
            sync: true
          },

          /**
           * When `positionTarget` is set, this property defines whether to align the overlay's
           * top or bottom side to the target element by default.
           * Possible values are `top` and `bottom`.
           * The overlay is automatically flipped to the opposite side when it doesn't fit into
           * the default side defined by this property.
           *
           * @attr {top|bottom} vertical-align
           */
          verticalAlign: {
            type: String,
            value: 'top',
            sync: true
          },

          /**
           * When `positionTarget` is set, this property defines whether the overlay should overlap
           * the target element in the x-axis, or be positioned right next to it.
           *
           * @attr {boolean} no-horizontal-overlap
           */
          noHorizontalOverlap: {
            type: Boolean,
            value: false,
            sync: true
          },

          /**
           * When `positionTarget` is set, this property defines whether the overlay should overlap
           * the target element in the y-axis, or be positioned right above/below it.
           *
           * @attr {boolean} no-vertical-overlap
           */
          noVerticalOverlap: {
            type: Boolean,
            value: false,
            sync: true
          },

          /**
           * If the overlay content has no intrinsic height, this property can be used to set
           * the minimum vertical space (in pixels) required by the overlay. Setting a value to
           * the property effectively disables the content measurement in favor of using this
           * fixed value for determining the open direction.
           *
           * @attr {number} required-vertical-space
           */
          requiredVerticalSpace: {
            type: Number,
            value: 0,
            sync: true
          }
        };
      }
    }, {
      key: "observers",
      get: function get() {
        return ['__positionSettingsChanged(horizontalAlign, verticalAlign, noHorizontalOverlap, noVerticalOverlap, requiredVerticalSpace)', '__overlayOpenedChanged(opened, positionTarget)'];
      }
    }]);

    return PositionMixin;
  }(superClass);
};